export function getRiskColor(level, isDark) {
  const key = level?.toLowerCase();
  if (isDark) {
    if (key === "low") return "text-emerald-400 bg-emerald-500/10 border-emerald-500/30";
    if (key === "medium") return "text-amber-400 bg-amber-500/10 border-amber-500/30";
    if (key === "high") return "text-red-400 bg-red-500/10 border-red-500/30";
    return "text-gray-400 bg-gray-500/10 border-gray-500/30";
  }
  if (key === "low") return "text-emerald-600 bg-emerald-50 border-emerald-200";
  if (key === "medium") return "text-amber-600 bg-amber-50 border-amber-200";
  if (key === "high") return "text-red-600 bg-red-50 border-red-200";
  return "text-gray-600 bg-gray-50 border-gray-200";
}

export function getRiskIconColor(level) {
  const key = level?.toLowerCase();
  if (key === "high") return "text-red-400";
  if (key === "medium") return "text-amber-400";
  if (key === "low") return "text-emerald-400";
  return "text-gray-400";
}

export function getProbabilityColor(score) {
  if (score >= 0.8) return "#10b981";
  if (score >= 0.7) return "#a855f7";
  if (score >= 0.6) return "#f59e0b";
  return "#ef4444";
}

export function getStatusBadgeClass(status, isDark) {
  if (status === "open") {
    return isDark
      ? "text-blue-400 bg-blue-500/10 border-blue-500/30"
      : "text-blue-600 bg-blue-50 border-blue-200";
  }
  return isDark
    ? "text-gray-400 bg-gray-500/10 border-gray-500/30"
    : "text-gray-500 bg-gray-100 border-gray-200";
}

export function getFilterButtonClass(isActive, isDark) {
  if (isActive) return "border-purple-500 bg-purple-500/10";
  return isDark
    ? "border-white/10 bg-[#12121a] hover:border-purple-500/30"
    : "border-gray-200 bg-white hover:border-purple-300";
}

export function getFilterTextClass(isActive, isDark) {
  if (isActive) return "text-purple-500";
  return isDark ? "text-white" : "text-gray-900";
}

export function getFilterIconClass(isActive, isDark) {
  if (isActive) return "text-purple-500";
  return isDark ? "text-gray-500" : "text-gray-400";
}

export function getCardClass(isDark) {
  return isDark ? "bg-[#12121a] border-white/10" : "bg-white border-gray-200";
}

export function getWatchlistToggleClass(isWatchlisted, isDark) {
  if (isWatchlisted) return "text-amber-400 bg-amber-500/10 hover:bg-amber-500/20";
  return isDark
    ? "text-gray-500 hover:text-amber-400 hover:bg-white/5"
    : "text-gray-400 hover:text-amber-500 hover:bg-gray-100";
}

export function getOppItemClass(isSelected, isDark) {
  if (isSelected) return "border-purple-500 bg-purple-500/10";
  return isDark
    ? "border-white/10 hover:border-purple-500/30 bg-[#0c0c16]"
    : "border-gray-200 hover:border-purple-300 bg-gray-50";
}

export function getStatusBadgeClassForItem(statusCfg, isDark) {
  return isDark ? statusCfg.color : statusCfg.colorLight;
}

export function getTextPrimary(isDark) {
  return isDark ? "text-white" : "text-gray-900";
}

export function getTextSecondary(isDark) {
  return isDark ? "text-gray-500" : "text-gray-400";
}

export function getTextMuted(isDark) {
  return isDark ? "text-gray-600" : "text-gray-400";
}

export function getDividerClass(isDark) {
  return isDark ? "divide-white/5" : "divide-gray-100";
}

export function getHoverRowClass(isDark) {
  return isDark ? "hover:bg-white/[0.02]" : "hover:bg-gray-50";
}

export function getBorderClass(isDark) {
  return isDark ? "border-white/10" : "border-gray-200";
}

export function getInactiveFilterClass(isDark) {
  return isDark
    ? "bg-white/5 text-gray-400 hover:bg-white/10"
    : "bg-gray-100 text-gray-600 hover:bg-gray-200";
}

export function getDealsFilterBadgeClass(isActive, isDark) {
  if (isActive) return "border-purple-500/30 text-purple-400";
  return isDark ? "border-white/10 text-gray-500" : "border-gray-200 text-gray-400";
}

export function getImpactColor(impact) {
  if (impact === "positive") return "#10b981";
  if (impact === "negative") return "#ef4444";
  return "#6b7280";
}
